<template>
    <div class="detail-info-manage">
        <!-- 统计卡片 -->
        <div class="stats-row">
            <div class="stat-card stat-total">
                <div class="stat-icon-wrap">
                    <i class="el-icon-office-building"></i>
                </div>
                <div class="stat-info">
                    <div class="stat-number">{{ countData.totalCount || 0 }}</div>
                    <div class="stat-desc">企业数量</div>
                </div>
            </div>
            <div class="stat-card stat-unapproved">
                <div class="stat-icon-wrap">
                    <i class="el-icon-warning"></i>
                </div>
                <div class="stat-info">
                    <div class="stat-number">{{ countData.unApprovalCount || 0 }}</div>
                    <div class="stat-desc">未认证</div>
                </div>
            </div>
            <div class="stat-card stat-pending">
                <div class="stat-icon-wrap">
                    <i class="el-icon-time"></i>
                </div>
                <div class="stat-info">
                    <div class="stat-number">{{ countData.underApprovalCount || 0 }}</div>
                    <div class="stat-desc">认证中</div>
                </div>
            </div>
            <div class="stat-card stat-approved">
                <div class="stat-icon-wrap">
                    <i class="el-icon-circle-check"></i>
                </div>
                <div class="stat-info">
                    <div class="stat-number">{{ countData.approvalCount || 0 }}</div>
                    <div class="stat-desc">认证成功</div>
                </div>
            </div>
        </div>

        <!-- 查询区域 -->
        <el-card class="search-card" shadow="never">
            <el-form :inline="true">
                <el-form-item label="认证状态">
                    <el-select v-model="authState" placeholder="请选择" clearable style="width: 140px;">
                        <el-option label="全部" value="全部"></el-option>
                        <el-option label="未认证" value="未认证"></el-option>
                        <el-option label="认证中" value="认证中"></el-option>
                        <el-option label="认证驳回" value="认证驳回"></el-option>
                        <el-option label="认证成功" value="认证成功"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="企业名称">
                    <el-input v-model="keyword" placeholder="请输入企业名称" clearable style="width: 200px;"
                        @keydown.enter.native="doSearch"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="doSearch">查询</el-button>
                    <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
                </el-form-item>
            </el-form>
        </el-card>

        <!-- 数据表格 -->
        <el-card class="table-card" shadow="never">
            <component v-bind:is="currentName" @changeName="changeName"></component>
            <el-table v-if="currentName === ''" :data="tableData" border
                :header-cell-style="{ background: '#f5f7fa', color: '#606266', fontWeight: '600' }"
                style="width: 100%;">
                <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                <el-table-column prop="companyName" label="企业名称" min-width="200" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="socialCreditCode" label="统一社会信用代码" min-width="180" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="userId" label="企业账号" min-width="140" align="center"></el-table-column>
                <el-table-column label="认证状态" width="110" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="getAuthStateTagType(scope.row.authState)" size="small" effect="light">
                            {{ scope.row.authState }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="contactsName" label="联系人" width="100" align="center"></el-table-column>
                <el-table-column prop="contactsPhone" label="联系电话" width="130" align="center"></el-table-column>
                <el-table-column label="账号状态" width="100" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.state === '正常' ? 'success' : 'danger'" size="small" effect="light">
                            {{ scope.row.state }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="260" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleQuery(scope.row)">查看详情</el-button>
                        <el-button size="mini" :type="scope.row.state === '正常' ? 'danger' : 'success'"
                            @click="handleDisable(scope.row)">
                            {{ scope.row.state === '正常' ? '禁用' : '启用' }}
                        </el-button>
                        <el-button size="mini" type="info" @click="handleChangePassword(scope.row)">修改密码</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div v-if="currentName === ''" class="pagination-wrap">
                <el-pagination
                    layout="total, sizes, prev, pager, next"
                    :total="boardsTotal"
                    :page-size="pageSize"
                    :current-page="currPage"
                    :page-sizes="[10, 20, 50, 100]"
                    @current-change="handleCurrentChange"
                    @size-change="handleSizeChange">
                </el-pagination>
            </div>
        </el-card>
    </div>
</template>

<script>
import AddBoardContent from "../../components/AddBoardContent";

export default {
    name: "PublishBoard",
    data() {
        return {
            boardsTotal: 1,
            currPage: 1,
            pageSize: 10,
            keyword: '',
            authState: '',
            currentName: '',
            tableData: [],
            columnWidth: 180,
            countData: {
                totalCount: 0,
                unApprovalCount: 0,
                underApprovalCount: 0,
                approvalCount: 0
            }
        }
    },
    components: {
        AddBoardContent
    },
    watch: {},
    mounted() {
        this.initTableData('');
        this.getCountData();
    },
    methods: {
        handleCurrentChange(val) {
            this.currPage = val;
            this.initTableData(this.keyword);
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.initTableData(this.keyword);
        },
        initTableData(keyword) {

            let user = JSON.parse(window.localStorage.getItem('user'));
            //console.log("useId:  " + user.id)


            this.getRequest('/web/companyInfo/queryListByState?authState=' + this.authState + '&keyword=' + this.keyword + '&currPage=' + this.currPage + '&pageSize=' + this.pageSize).then(resp => {
                //console.log(resp.data);
                if (resp) {
                    this.boardsTotal = resp.data.total;
                    this.tableData = resp.data.list;
                }
            });
        },
        doSearch() {
            this.currPage = 1;
            this.initTableData(this.keyword);
        },
        resetSearch() {
            this.keyword = '';
            this.authState = '';
            this.currPage = 1;
            this.initTableData('');
        },
        getAuthStateTagType(authState) {
            if (authState === '认证成功' || authState === '认证审核通过') return 'success';
            if (authState === '认证驳回' || authState === '未认证') return 'danger';
            if (authState === '认证审核中' || authState === '认证中') return 'warning';
            return 'info';
        },
        changeName(name) {
            //console.log(this.currentName)
            this.currentName = name;
            if (name === '') {
                this.initTableData('');
                this.$store.commit('REMOVE_CURRENT_BOARD_ID');
            }
        },
        handleEdit(obj) {
            try {
                const user = JSON.parse(localStorage.getItem('user'));
                if (!user || !user.id) {
                    throw new Error('无法获取用户信息');
                }

                this.$router.push({
                    path: '/company/DetailModifyManage',
                    query: {
                        companyId: obj.companyId || obj.companyId
                    }
                });
            } catch (error) {
                console.error('跳转编辑页面失败:', error);
                this.$message.error('跳转编辑页面失败: ' + error.message);
            }
        },
        handleDelete(obj) {
            this.$confirm('是否永久删除名为：【' + obj.assetName + '】的数据资产？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteRequest("/web/board/" + obj.id).then(resp => {
                    this.initTableData('');
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        publishedSwitch(obj) {
            this.getRequest('/web/changeBoard/published?id=' + obj.id + '&published=' + obj.published).then(resp => {
            });
        },
        goToRegistration() {
            this.$router.push('/index/data-registration');
        },
        handleQuery(row) {
            try {
                const user = JSON.parse(localStorage.getItem('user'));
                if (!user || !user.id) {
                    throw new Error('无法获取用户信息');
                }

                this.$router.push({
                    path: '/index/company/companyInfoView',
                    query: {
                        companyId: row.companyId || row.companyId
                    }
                });
            } catch (error) {
                console.error('跳转详情页面失败:', error);
                this.$message.error('跳转详情页面失败: ' + error.message);
            }
        },
        handleReview(row) {
            try {
                const user = JSON.parse(localStorage.getItem('user'));
                if (!user || !user.id) {
                    throw new Error('无法获取用户信息');
                }

                this.$router.push({
                    path: '/index/company/company-review',
                    query: {
                        companyId: row.companyId || row.companyId,
                        formData: JSON.stringify(row)
                    }
                });
            } catch (error) {
                console.error('跳转审核页面失败:', error);
                this.$message.error('跳转审核页面失败: ' + error.message);
            }
        },
        handleChangePassword(row) {
            // 修改密码逻辑
            this.$message.info('修改密码功能待实现');
        },
        handleDisable(row) {
            const action = row.state === '正常' ? '禁用' : '启用';
            const apiUrl = row.state === '正常' ? '/web/companyInfo/disable' : '/web/companyInfo/enable';

            this.$confirm(`确定要${action}企业【${row.companyName}】的账号吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios.get(apiUrl, {
                    params: {
                        companyId: row.companyId
                    }
                }).then(resp => {
                    if (resp && resp.data.status === 200) {
                        this.$message.success(`${action}成功`);
                        this.initTableData(''); // 刷新表格数据
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: `已取消${action}`
                });
            });
        },
        getCountData() {
            this.getRequest('/web/companyInfo/queryCount').then(resp => {
                if (resp && resp.data) {
                    this.countData = resp.data;
                }
            }).catch(error => {
                console.error('获取统计数据失败:', error);
            });
        }
    }
}
</script>


<style scoped>
.detail-info-manage {
    padding: 20px 24px;
    background: #f0f2f5;
    min-height: 100%;
}

.stats-row {
    display: flex;
    gap: 16px;
    margin-bottom: 16px;
}

.stat-card {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 16px;
    background: #fff;
    border-radius: 10px;
    padding: 20px 24px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
    border-left: 4px solid transparent;
    transition: box-shadow 0.2s;
}

.stat-card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.stat-total { border-left-color: #67C23A; }
.stat-unapproved { border-left-color: #F56C6C; }
.stat-pending { border-left-color: #E6A23C; }
.stat-approved { border-left-color: #409EFF; }

.stat-icon-wrap {
    width: 48px;
    height: 48px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    flex-shrink: 0;
}

.stat-total .stat-icon-wrap { background: #f0f9eb; color: #67C23A; }
.stat-unapproved .stat-icon-wrap { background: #fef0f0; color: #F56C6C; }
.stat-pending .stat-icon-wrap { background: #fdf6ec; color: #E6A23C; }
.stat-approved .stat-icon-wrap { background: #ecf5ff; color: #409EFF; }

.stat-number {
    font-size: 28px;
    font-weight: 700;
    line-height: 1;
    margin-bottom: 4px;
}

.stat-total .stat-number { color: #67C23A; }
.stat-unapproved .stat-number { color: #F56C6C; }
.stat-pending .stat-number { color: #E6A23C; }
.stat-approved .stat-number { color: #409EFF; }

.stat-desc {
    font-size: 13px;
    color: #909399;
}

.search-card {
    margin-bottom: 16px;
    border-radius: 10px;
    border: none;
}

.search-card >>> .el-card__body {
    padding: 16px 20px 4px;
}

.search-card >>> .el-form-item {
    margin-bottom: 12px;
    margin-right: 16px;
}

.table-card {
    border-radius: 10px;
    border: none;
}

.table-card >>> .el-card__body {
    padding: 16px 20px;
}

.table-card >>> .el-table th {
    font-weight: 600;
}

.table-card >>> .el-table td {
    padding: 10px 0;
}

.pagination-wrap {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
}
</style>
